export default __webpack_public_path__ + "static/media/vendor_credit_note.44636b4b.xlsx";